<template>
  <div class="row">
    <div class="col-md-12">

      <h4>{{ $t('Buscador avanzado Infantil') }}</h4>
      
      <div class="select-search-form">
        <button :class=" ['cine', 'series', 'documentales', 'todos'].includes(searchCategory) ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('cine')">{{ $t('Cine y TV') }}</button>
        <button :class="(searchCategory == 'musica') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('musica')">{{ $t('Música') }}</button>
        <button :class="(searchCategory == 'libros') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('libros')">{{ $t('Libros') }}</button>
        <!-- <button :class="(searchCategory == 'series') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('series')">{{ $t('Series') }}</button>
        <button :class="(searchCategory == 'documentales') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('documentales')">{{ $t('Documentales') }}</button> -->
      </div>


      
      <br /><br />

      <div v-if=" ['cine', 'series', 'documentales', 'todos'].includes(searchCategory) ">

        <div class="select-search-form">
          <button :class="(searchCategory == 'todos') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('todos')">{{ $t('Todos') }}</button>
          <button :class="(searchCategory == 'cine') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('cine')">{{ $t('Cine') }}</button>
          <button :class="(searchCategory == 'series') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('series')">{{ $t('Series') }}</button>
          <button :class="(searchCategory == 'documentales') ? 'buscador-btn active' : 'buscador-btn' " @click="setSearchCategory('documentales')">{{ $t('Documentales') }}</button>
        </div>

        <buscador-avanzado-cine-tv :searchCategory="searchCategory" class="mt40">
        </buscador-avanzado-cine-tv>

      </div>
      
      
      <!-- <buscador-avanzado-csd searchCategory="cine"
        v-if=" searchCategory == 'cine' ">
      </buscador-avanzado-csd> -->

      <buscador-avanzado-musica searchCategory="musica"
        v-if=" searchCategory == 'musica' ">
      </buscador-avanzado-musica>

      <buscador-avanzado-libros searchCategory="libros"
        v-if=" searchCategory == 'libros' ">
      </buscador-avanzado-libros>

      <!-- <buscador-avanzado-csd searchCategory="series"
        v-if=" searchCategory == 'series' ">
      </buscador-avanzado-csd> -->

      <!-- <buscador-avanzado-csd searchCategory="documentales"
        v-if=" searchCategory == 'documentales' ">
      </buscador-avanzado-csd> -->

      <br /> <br />
     
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Buscador avanzado Infantil": "Buscador avanzado Infantil",
    "Todos": "Todos",
    "Cine": "Cine",
    "Cine y TV": "Cine y TV",
    "Música": "Música",
    "Libros": "Libros",
    "Documentales": "Documentales",
    "Series": "Series"
  },
  "en": {
  },
  "ca": {
    "Buscador avanzado Infantil": "Cercador avançat Infantil",
    "Todos": "Tots",
    "Cine": "Cinema",
    "Cine y TV": "Cinema i TV",
    "Música": "Música",
    "Libros": "Llibres",
    "Documentales": "Documentals",
    "Series": "Sèries"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';
  //import BuscadorAvanzadoCsd from './BuscadorAvanzadoCsd.vue';
  import BuscadorAvanzadoCineTv from './BuscadorAvanzadoCineTv.vue';
  import BuscadorAvanzadoMusica from './BuscadorAvanzadoMusica.vue';
  import BuscadorAvanzadoLibros from './BuscadorAvanzadoLibros.vue';

  export default {
    components: { BuscadorAvanzadoCineTv, BuscadorAvanzadoMusica, BuscadorAvanzadoLibros },
    data: () => {
      return{
        searchCategory: '',
      }
    },
    mounted(){
    },
    computed: {
      ...mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
    },
    methods: {
      setSearchCategory(value){
        this.searchCategory = value;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
